import {Typography, Box} from '@mui/material';
import {BODY1, H5, OUTLINE} from '@/utils/constants';
import {needBeLoggedStyle} from './NeedBeLogged.styles';
import Button from '@/shared/components/Button';
import ActionUserNotLogined from '../ActionUserNotLogined';

const NeedBeLoggedModal = ({handleClose}: {handleClose: () => void}) => {
  return (
    <Box sx={{height: '100%', display: 'flex', flexDirection: 'column', overflow:'hidden'}}>
      <Typography sx={needBeLoggedStyle.title} variant={H5}>
        Please Log In To Continue
      </Typography>
      <Typography sx={needBeLoggedStyle.afterTitle} variant={BODY1}>
        Log in or create an account to bid, donate, and participate.
      </Typography>
      <Box sx={needBeLoggedStyle.btnWrapper}>
        <Button title="Cancel" onClick={handleClose} variant={OUTLINE} sx={needBeLoggedStyle.cancelBtn} />
        <ActionUserNotLogined onClose={handleClose} title="Log In / Create Account" parentClassName={needBeLoggedStyle.btn} />
      </Box>
    </Box>
  );
};

export default NeedBeLoggedModal;
